<template>
  <div class="component-container">
    <div class="title">找回密码</div>
    <div class="account-box">
      <div class="account-img">
        <img class="image" src="@/assets/icon_account.png" />
      </div>
      <div class="account-input">
        <el-input
          :readonly="readonly"
          @click.native="handlerIptClick"
          v-model="params.phone"
          autocomplete="off"
          placeholder="请输入手机号"
        />
      </div>
    </div>
    <div class="account-box verification-code-box">
      <div class="account-img">
        <img class="image-code" src="@/assets/icon_verification_code.png" />
      </div>
      <div class="account-input-code">
        <el-input
          :readonly="readonly"
          @click.native="handlerIptClick"
          v-model="params.securityCode"
          autocomplete="off"
          placeholder="请输入验证码"
        />
      </div>
      <div class="get-code" @click="onGetCodeClick">
        {{ time >= 60 ? codeText : time + "s" }}
      </div>
    </div>
    <div class="account-box">
      <div class="account-img">
        <img class="image" src="@/assets/icon_password.png" />
      </div>
      <div class="account-input">
        <el-input
          :readonly="readonly"
          @click.native="handlerIptClick"
          v-model="params.password"
          show-password
          autocomplete="off"
          placeholder="请输入密码"
        />
      </div>
    </div>
    <div class="account-box">
      <div class="account-img">
        <img class="image" src="@/assets/icon_password.png" />
      </div>
      <div class="account-input">
        <el-input
          :readonly="readonly"
          @click.native="handlerIptClick"
          v-model="params.confirmPassword"
          show-password
          autocomplete="off"
          placeholder="请确认密码"
        />
      </div>
    </div>
    <el-button :loading="loading" class="login-btn" @click="onSureClick"
      >确 定</el-button
    >
    <div class="bottom-box" @click="onGotoLoginClick">去登陆</div>
  </div>
</template>
<script>
import { getSendForgetCode, getFindPassword } from "@/api/login.js";
import AES from "@/utils/AES.js";
export default {
  name: "ForgetPassword",
  data() {
    return {
      readonly: true,
      params: {
        phone: "",
        securityCode: "",
        password: "",
        confirmPassword: "",
      },
      loading: false,
      time: 60,
      codeText: "获取验证码",
      timeinterval: undefined,
    };
  },
  beforeDestroy() {
    if (this.timeinterval) {
      clearInterval(this.timeinterval);
    }
  },
  methods: {
    handlerIptClick() {
      this.readonly = false;
    },
    //获取验证码
    onGetCodeClick() {
      const { phone } = this.params;
      if (!phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.time < 60) return;
      this.time--;
      this.timeinterval = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(this.timeinterval);
          this.time = 60;
          this.codeText = "重新获取";
        }
      }, 1000);
      this._getSendForgetCode();
    },
    onSureClick() {
      const { phone, password, securityCode, confirmPassword } = this.params;
      if (!phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!securityCode) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!password) {
        this.$message.error("请输入密码");
        return;
      }
      if (password !== confirmPassword) {
        this.$message.error("两次密码输入不一致");
        return;
      }
      this._getFindPassword();
    },
    onGotoLoginClick() {
      this.$emit("onLoginClick");
    },
    //发送忘记验证码
    _getSendForgetCode() {
      const { phone } = this.params;
      getSendForgetCode({ phone })
        .then((res) => {
          const { message } = res;
          this.$message.success(message||'发送成功');
        })
        .catch(() => {});
    },
    //忘记密码
    _getFindPassword() {
      const { password, confirmPassword } = this.params;
      this.loading = true;
      getFindPassword({
        ...this.params,
        password: AES.encrypt(password),
        confirmPassword: AES.encrypt(confirmPassword),
      })
        .then((res) => {
          const { message } = res;
          this.$message.success(message||'操作成功');
          this.loading = false;
          this.$emit("onLoginClick");
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.component-container {
  padding-top: 35px;
  padding-left: 32px;
  text-align: left;
  .title {
    font-size: 24px;
    color: #333333;
    padding-bottom: 20px;
  }
  .account-box {
    display: flex;
    align-items: center;
    margin-top: 28px;
    margin-left: 20px;
    .account-img {
      .image {
        width: 30px;
      }
      .image-code {
        width: 40px;
        margin-left: -5px;
        margin-right: -5px;
      }
    }
    .account-input,
    .account-input-code {
      margin-left: 10px;
      .el-input {
        width: 360px;
      }
    }
    .account-input-code {
      .el-input {
        width: 240px;
      }
    }
    .get-code {
      width: 125px;
      height: 40px;
      margin-left: -5px;
      z-index: 2;
      line-height: 40px;
      text-align: center;
      background: #1082ff;
      border-radius: 0px 4px 4px 0px;
      font-size: 14px;
      cursor: pointer;
      color: #ffffff;
    }
  }
  .verification-code-box {
    margin-top: 25px;
  }
  .login-btn {
    width: 400px;
    height: 60px;
    margin-top: 50px;
    margin-left: 20px;
    text-align: center;
    background-color: #1082ff;
    border-radius: 4px;
    color: #ffffff;
    font-size: 24px;
    cursor: pointer;
  }
  .bottom-box {
    font-size: 14px;
    text-align: center;
    padding: 30px;
    cursor: pointer;
    margin-right: 50px;
    color: #1082ff;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/forgetpassword.vue